import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DataBaseProvider } from '../../providers/data-base/data-base';
import { Observable } from 'rxjs';
import { ListBillingPage } from '../list-billing/list-billing';
import { UserDetailsPage } from '../user-details/user-details';
import { DailyActivityPage } from '../daily-activity/daily-activity';
import { AuthServiceProvider } from '../../providers/auth-service/auth-service';

/**
 * shows the list of all users to Admin 
 * From this page Admin can 
 * See the billing page for a particular user 
 * View and edit the detail of a user
 */

@IonicPage()
@Component({
  selector: 'page-all-users',
  templateUrl: 'all-users.html',
})
export class AllUsersPage {
  allUsers: Observable<any>;
  isSuperAdmin: Observable<any>;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public $db: DataBaseProvider,
    private $auth: AuthServiceProvider) {
    this.allUsers = $db.getAllUsers();
    this.isSuperAdmin = $auth.isSuperAdmin();
  }

  ionViewDidLoad() {

  }

  getUserInfo(userKey): Observable<any> {
    return this.$db.getUserInfo(userKey);
  }

  updateUserInfo(userInfo: any, userKey: String): Promise<any> {
    return this.$db.updateUserInfo(userInfo, userKey);
  }

  navigateToBills(userKey) {
    this.navCtrl.push(ListBillingPage, { userKey: userKey });
  }


  navigateToUserDetails(userKey) {
    this.navCtrl.push(UserDetailsPage, { userKey: userKey });
  }

  navigateToUserLogs(userKey) {
    this.navCtrl.push(DailyActivityPage, { userKey: userKey });
  }

  onMachineTypeChange(userData) {
    const userKey = userData.key;
    // key need not go as an attribute 
    delete userData.key;
    this.$db.updateUserInfo(userData,userKey);
  }

}



// WEBPACK FOOTER //
// ./src/pages/all-users/all-users.ts